import React, {lazy} from "react";
import { Contact } from '../../contact';
import "./NoService.css";

export default class NoService extends React.Component {
  render() {
           {/* Fixme */}
    // can only render this if store settings were obtained and it indicated that a expired registration link was used. 
    const contacts = this.props.msg && this.props.msg.includes("expired") ?     lazy(() => import("../../contact/")) : null; 

    return (

      <div id="extr-page">

        <div id="main" role="main">
          <form className="noservice animated flipInY" action="#/dashboard/analytics">
            <div>
              <div>
                <h1>
                  <i className="fa fa-user fa-2x text-muted air air-top-right hidden-mobile" />
                  {this.props.msg}
                </h1>
              </div>
            </div>

            {contacts}
          </form>
        </div>
      </div>

    );
  }

}

